import { IBaseLoaderProps } from '../../feedback-ui/feedback-ui.types';
import { loaderSubtypeStrategy } from './loader-subtype.strategy';

export function BaseLoader({ uiSubtype, ...props }: IBaseLoaderProps) {
  return uiSubtype && loaderSubtypeStrategy[uiSubtype](props);
}
